import React from 'react';
import { Form, Checkbox, Button } from 'antd';
import type { ScheduleFormModalProps } from './types';
import { DAY_OPTIONS } from './constants';
import { StyledModal, StyledFormItem, StyledInput, CheckboxGroupWrapper, ModalFooterWrap, CancelButton } from './styles';

const ScheduleFormModal: React.FC<ScheduleFormModalProps> = ({
  open,
  isEdit,
  scheduleData,
  onClose,
  onSubmit,
  onInputChange,
  onDayNamesChange,
  submitting,
}) => (
  <StyledModal
    title={isEdit ? 'Edit Schedule' : 'Create Schedule'}
    open={open}
    onCancel={onClose}
    onOk={onSubmit}
    okText={isEdit ? 'Update' : 'Create'}
    cancelText="Cancel"
    confirmLoading={submitting}
    destroyOnClose
    maskClosable={false}
    footer={
      <ModalFooterWrap>
        <CancelButton onClick={onClose}>Cancel</CancelButton>
        <Button type="primary" loading={submitting} onClick={onSubmit}>
          {isEdit ? 'Update' : 'Create'}
        </Button>
      </ModalFooterWrap>
    }
  >
    <Form layout="vertical">
      <StyledFormItem label="Select Days">
        <CheckboxGroupWrapper>
          <Checkbox.Group
            options={DAY_OPTIONS.map((d) => ({ label: d.label, value: d.value }))}
            value={scheduleData.day_names}
            onChange={(vals) => onDayNamesChange(vals as string[])}
          />
        </CheckboxGroupWrapper>
      </StyledFormItem>
      <StyledFormItem label="Start Time" required>
        <StyledInput
          type="time"
          name="start_time"
          value={scheduleData.start_time}
          onChange={onInputChange}
        />
      </StyledFormItem>
      <StyledFormItem label="End Time" required>
        <StyledInput
          type="time"
          name="end_time"
          value={scheduleData.end_time}
          onChange={onInputChange}
        />
      </StyledFormItem>
    </Form>
  </StyledModal>
);

export default React.memo(ScheduleFormModal);
